import React from 'react'
import { FiStar } from 'react-icons/fi'
import { FollowButton } from './followButton'
import { ConnectButton } from './connectButton'

export const Aboutme = ({person}) => {

    const user = { name:'Hasan Azam', avatar:'/assets/images/faces/1.png', }


    return (<div className="aboutme">
        <div className="bg"></div>
        {!person && (
            <div className="user">
             {!user.avatar && <img src="/assets/images/faces/default.svg" alt="" />}
             {user.avatar && <img src={user.avatar} alt="" />}
             <h2>{user.first ? user.first +' '+ user.last : user.name}</h2>
             <p>{user.slug && `@${user.slug}`}</p> {/* Microsoft */}
             <p>{user.email}</p>  {/* C++ Developer  */}
             <p className="description">{user.bio}</p>  {/** Microsoft is the largest operating system company in the world */}
        </div>
        )}
        {person && (
            <div className="user">
             {!person.avatar && <img src="/assets/images/faces/default.svg" alt="" />}
             {person.avatar && <img src={person.avatar} alt="" />}
             <h2>{person.first ? person.first +' '+ person.last : person.name}</h2>
             <p>{'@'+person.slug}</p> {/* Microsoft */}
             <p>{person.email}</p>  {/* C++ Developer  */}
             <p className="description">{person.bio}</p>  {/** Microsoft is the largest operating system company in the world */}
        </div>
        )}

        
        <div className="score">
            <h3 className="score_title">3,5</h3>
            <div className="stars">
                <FiStar />
                <FiStar />
                <FiStar />
                <FiStar className="gray" />
                <FiStar className="gray" />
            </div>
        </div>

        <ul className="actions">
            <li>
               <FollowButton 
                 id={ 1 }
               />
            </li>
            <li className="">
               <ConnectButton />
            </li>
        </ul>

    </div>)
}

